import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container } from "react-bootstrap";

import { getChat, initGetChat } from "../../Store/actions/index";
import Card from "./DealerCard";
import Chats from "./Chat";
import SendMessage from "./SendMessage";
import { useHistory } from "react-router";
import logo from "../../assets/Img/pcariMainToolBarLogo.png";
import ChatLoader from "./ChatLoader";

export default function Conversation({ chatId, messagesLoading }) {
  const router = useHistory();

  const dispatch = useDispatch();

  const { user, currentUser } = useSelector((state) => state.Auth);

  const { chat, loading, error } = useSelector((state) => state.Chat);

  useEffect(() => {
    const token = localStorage.getItem("idToken");
    if (!token) router.push("/");
    else dispatch(initGetChat());
  }, []);

  useEffect(() => {
    if (chatId && user) {
      dispatch(initGetChat());
      dispatch(getChat(chatId));
    }
  }, [chatId, user]);

  return chatId ? (
    <>
      {(loading || messagesLoading) && (
        <Container>
          <ChatLoader />
        </Container>
      )}
      {!loading && !messagesLoading && chat && currentUser && (
        <div
          style={{
            boxShadow: "0 0 3px 1px #96969680",
            borderRadius: "11px",
            position: "relative",
          }}
        >
          <Card chat={chat.chat_participants} userId={currentUser.id} />
          <Chats
            chatMessages={chat.chat_messages}
            userId={currentUser.id}
            chatId={chat.id}
          />
          <SendMessage
            particpatntArr={chat.chat_participants}
            userId={currentUser.id}
            chatId={chat.id}
            chat={chat}
          />
        </div>
      )}
    </>
  ) : (
    // : messagesLoading ? (
    //   <Container>
    //     <ChatLoader />
    //   </Container>
    // )
    <Container className="p-4 bg-light h-50 d-flex flex-column justify-content-center align-items-center">
      <p
        style={{
          textAlign: "center",
          fontSize: ".9rem",
          color: "#606161",
          fontWeight: "bolder",
        }}
      >
        Select Chat
      </p>
      <img src={logo} className="w-50" />
    </Container>
  );
}
